import { api } from '@/lib/api-client'
import { serializeSubscriptionQuery, type SubscriptionQuery } from './get-subscriptions'

export const exportSubscriptions = async (params?: SubscriptionQuery): Promise<void> => {
    // Use the shared API client to ensure auth/cookies are included
    const blob: Blob = await api.get('/v2/subscriptions/export', {
        params: serializeSubscriptionQuery(params),
        responseType: 'blob',
    } as any)

    // Fallback filename (server also returns a filename, but headers are not available via api interceptor)
    const fileName = 'subscriptions_export.csv'

    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(objectUrl)
}

